import commonJsModule from "read-file-yaml"

export default commonJsModule.default